// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner__Loader__1DDwY","load7":"Spinner__load7__2S5ij"};